<template>
<div class="chapter">
<div class="inner_page">
<a id="page_3"></a>
<h1 class="toc-title">Contents</h1>
<h2 class="toc"><a href="#/xhtml/05_Foreword"><span class="bold">Foreword</span></a></h2>
<h2 class="toc"><a href="#/xhtml/06_Introduction"><span class="bold">Introduction</span></a></h2>
<h2 class="toc"><a href="#/xhtml/07_Chapter01">Chapter One</a></h2>
<h2 class="toc1"><a href="#/xhtml/07_Chapter01#ch1"><span class="bold">Early Years</span></a></h2>
<h2 class="toc"><span href="#/xhtml/08_Chapter02" title="Link target outside of Sample">Chapter Two</span></h2>
<h2 class="toc1"><span href="#/xhtml/08_Chapter02#ch2" title="Link target outside of Sample"><span class="bold">Tannenberg</span></span></h2>
<h2 class="toc"><span href="#/xhtml/09_Chapter03" title="Link target outside of Sample">Chapter Three</span></h2>
<h2 class="toc1"><span href="#/xhtml/09_Chapter03#ch3" title="Link target outside of Sample"><span class="bold">Genocide</span></span></h2>
<h2 class="toc"><span href="#/xhtml/10_Chapter04" title="Link target outside of Sample">Chapter Four</span></h2>
<h2 class="toc1"><span href="#/xhtml/10_Chapter04#ch4" title="Link target outside of Sample"><span class="bold">Death and Retaliation</span></span></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter05" title="Link target outside of Sample">Chapter Five</span></h2>
<h2 class="toc1"><span href="#/xhtml/11_Chapter05#ch5" title="Link target outside of Sample"><span class="bold">In Memory</span></span></h2>
<h2 class="toc"><span href="#/xhtml/12_Appendix01" title="Link target outside of Sample">Appendix One</span></h2>
<h2 class="toc1"><span href="#/xhtml/12_Appendix01#app1" title="Link target outside of Sample"><span class="bold">Order from Hermann Göring to Reinhard Heydrich</span></span></h2>
<h2 class="toc"><span href="#/xhtml/13_Appendix02" title="Link target outside of Sample">Appendix One</span></h2>
<h2 class="toc1"><span href="#/xhtml/13_Appendix02#app2" title="Link target outside of Sample"><span class="bold">Wannsee Conference Minutes</span></span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?eb45cef4